import './demo.component.scss'

import { closeBanner, openBanner } from '../../application/core/banner'

const checkboxes = [...document.querySelectorAll('.demo-form__ceil_groupcheckbox [type=checkbox]')]

function handleCheckboxChange(currentCheckbox, allCheckboxes) {
	if (currentCheckbox.value.toLowerCase().includes('unsure') && currentCheckbox.checked) {
		allCheckboxes.forEach(i => {
			if (i !== currentCheckbox) {
				i.checked = false
			}
		})
	} else if (!currentCheckbox.value.toLowerCase().includes('unsure') && currentCheckbox.checked) {
		const unsureCheckbox = allCheckboxes.find(el => el?.value.toLowerCase().includes('unsure'))
		unsureCheckbox.checked = false
	}
}


if (checkboxes.length > 0) {
	checkboxes.forEach(item => {
		const cf7Label = item?.nextElementSibling

		if (cf7Label) {
			if (item.value.toLowerCase().includes('gateway')) {
				cf7Label.innerHTML = 'Gateway Solutions: </br> HostPay, DirectPay, VirtualPay, or CallSentry'
			} else if (item.value.toLowerCase().includes('unsure')) {
				cf7Label.innerHTML = '<span class="unsure">?</span>Unsure'
			} else {
				cf7Label.innerHTML = cf7Label.textContent
			}
			// item.value = cf7Label.textContent.replace(/\s+/g, ' ')
		}

		item.addEventListener('change', () => {
			handleCheckboxChange(item, checkboxes)
		})
	})
}


// Calendly widget
const btnSchedule = document.querySelector('.btn__schedule')

if (btnSchedule) {
	const scheduleTextNear = document.querySelector('.demo-form__text')
	const scheduleThxBanner = document.querySelector('.calendly-thx')
	const btnCloseScheduleThxBanner = scheduleThxBanner.querySelector('.calendly-thx-btn')
	let scriptAdded = false

	const loadCalendlyWidget = () => {
		if (!scriptAdded) {
			const scheduleContainer = document.querySelector('.calendly-widget')
			const script = document.createElement('script')
			script.src = 'https://assets.calendly.com/assets/external/widget.js'

			script.addEventListener('load', () => {
				const firstName = document.querySelector('#first-name').value
				const email = document.querySelector('#email-address').value

				Calendly.initInlineWidget({
					url: 'https://calendly.com/e-complishsales/30min',
					parentElement: scheduleContainer,
					prefill: {
						name: firstName,
						email: email,
					}
				})
			})
			scheduleContainer.appendChild(script)
			scriptAdded = true
		}
	}

	btnSchedule.addEventListener('click', event => {
		event.preventDefault()
		loadCalendlyWidget()
	})

	// message
	function isCalendlyEvent(e) {
		return e.origin === 'https://calendly.com' && e.data.event && e.data.event.indexOf('calendly.') === 0
	}

	window.addEventListener('message', function(e) {
		if(isCalendlyEvent(e)) {
			if(e.data.event == 'calendly.event_scheduled') {
			// if (e.data.event == 'calendly.date_and_time_selected') {
				scheduleTextNear.textContent = 'Your Demo is Scheduled'
				btnSchedule.classList.add('js-disabled')
				openBanner(scheduleThxBanner)
				btnCloseScheduleThxBanner.addEventListener('click', () => {
					closeBanner(scheduleThxBanner)
				})
			}
			//  Test Event
			// 	console.log("Event name:", e.data.event);
			// 	console.log("Event details:", e.data.payload);
			// 	console.log(e.data.event == 'calendly.date_and_time_selected', 'calendly.date_and_time_selected') // ! Date
			// 	console.log(e.data.event == 'calendly.event_scheduled', 'calendly.event_scheduled') // ! Final
		}
	})
}
